import {FC} from "react";
import {Box, Avatar, Typography, BoxProps} from "@mui/material";
import {makeStyles} from "tss-react/mui";
import {CommentDto} from "@/app2/shared/data/repos/comments";
import {CommentIndent} from "./CommentIndent";

const useStyles = makeStyles()((theme) => ({
	container: {
		display: "flex",
		flexDirection: "row",
		"a": {
			textDecoration: "none !important"
		}
	},
	avatarContainer: {
		display: "flex",
		flexDirection: "column",
		position: "relative"
	},
	avatar: {
		backgroundColor: "#2A2A2F",
		width: "48px",
		height: "48px"
	},
	authorContainer: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		marginBottom: "6px"
	},
	author: {
		fontSize: "13px",
		fontWeight: "700",
		color: "#2A2A2F",
		marginLeft: "0px"
	},
	time: {
		fontSize: "13px",
		fontWeight: "400",
		color: "#A8A8A8",
		marginLeft: "8px"
	},
	contentContainer: {
		marginLeft: "16px",
		display: "flex",
		flexDirection: "column",
		flex: "1",
		minWidth: 0
	},
	content: {
		fontSize: "16px",
		fontWeight: "400",
		color: "#2A2A2F",
		marginBottom: "28px",
		whiteSpace: "pre-wrap"
	},
	verticalLine: {
		width: "1px",
		backgroundColor: "#D8D8D8",
		flex: "1",
		marginLeft: "24px"
	}
}));

const getInitials = (name: string): string => {
	const parts = name.trim().split(/\s+/);
	if (parts.length >= 2) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
	return (name[0] || "?").toUpperCase();
};

const formatDate = (dateStr: string): string => {
	const date = new Date(dateStr);
	const now = new Date();
	const diff = Math.floor((now.getTime() - date.getTime()) / (1000 * 60 * 60 * 24));
	if (diff === 0) return "Today";
	if (diff === 1) return "Yesterday";
	if (diff <= 7) return `${diff} days ago`;
	return date.toLocaleDateString(undefined, { month: "numeric", day: "numeric", year: "numeric" });
};

export interface CommentCardProps extends BoxProps {
	comment: CommentDto;
	isChild?: boolean;
	translations?: { today?: string; yesterday?: string; daysAgo?: string };
}

export const CommentCard: FC<CommentCardProps> = ({comment, isChild = false, translations, ...props}) => {
	const {classes} = useStyles();
	const {author, content, createdAt} = comment;

	const dateStr = formatDate(createdAt);

	return (
		<Box className={classes.container} {...props}>
			{isChild && <CommentIndent />}
			<Box className={classes.avatarContainer}>
				<Avatar className={classes.avatar}>{getInitials(author.name)}</Avatar>
				{!isChild && <div className={classes.verticalLine} />}
			</Box>
			<Box className={classes.contentContainer}>
				<Box className={classes.authorContainer}>
					<Typography className={classes.author}>{author.name}</Typography>
					<Typography className={classes.time}>{dateStr}</Typography>
				</Box>
				<Typography variant="body2" className={classes.content}>
					{content}
				</Typography>
			</Box>
		</Box>
	);
};
